import { useState } from "react";
import { pickKey, useLandingFeed, type Pick } from "./feed";
import { useBeatPlayer } from "./audio";
import BetSlip from "./components/BetSlip";
import EarningsCalculator from "./components/EarningsCalculator";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import LiveContests from "./components/LiveContests";
import SiteFooter from "./components/SiteFooter";
import { ForFans, ForProducers } from "./components/ValueProps";
import WinTicker from "./components/WinTicker";
import WinnersWall from "./components/WinnersWall";

export default function App() {
  const feed = useLandingFeed();
  const live = feed?.liveContests ?? [];
  const winners = feed?.winnersWall ?? [];
  const player = useBeatPlayer();
  const [selection, setSelection] = useState<Pick | null>(null);

  return (
    <div className={`min-h-screen overflow-x-hidden bg-ground font-sans text-chrome antialiased ${selection ? "lg:pr-80" : ""}`}>
      <main>
        <Hero feed={feed} player={player} onBack={setSelection} slipOpen={selection !== null} />
        <WinTicker wins={feed?.recentWins ?? []} contests={live} />
        <HowItWorks />
        <LiveContests contests={live} player={player} onBack={setSelection} />
        <ForProducers winners={winners} />
        <ForFans hasLive={live.length > 0} />
        <EarningsCalculator contests={live} onBack={setSelection} />
        <WinnersWall winners={winners} />
      </main>
      <SiteFooter />
      {selection && <BetSlip key={pickKey(selection)} pick={selection} onClose={() => setSelection(null)} />}
      {player.elements}
    </div>
  );
}
